import { h } from "preact";
import { useState } from "preact/hooks";


export default function DevenirAmbassadeur() {


	return (<div>Vendre mon bien</div>)
}